import React, { useState } from 'react'
import { Form, Input, Spin } from 'antd'
import axios from 'axios'

const { Search } = Input
const App = () => {
  const formRef = React.useRef(null);
  const [result, setResult] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const onFinish = (values) => {
    const str = values.str
    if (!str) {
      return
    }
    fetchData(str)
  }
  const onSearch = (value) => {
    // 手动触发表单验证
    formRef.current.validateFields(['str']);
    if (!value) {
      return
    }
    fetchData(value)
  }
  const fetchData = async (str) => {
    setResult('')
    setIsLoading(true)
    const result = await axios.post(`html`, {
      url: `https://www.google.com/search?q=${encodeURIComponent(str)}`,
    })
    const html = result.data.html
    setIsLoading(false)
    let filteredHtml = html.replace(/\/url\?q=/g, '')
    filteredHtml = filteredHtml.replace(/(&amp;sa=U).*?(?=")/g, '');
    setResult(filteredHtml)
  }
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo)
  }
  return (
    <>
      <Form
        ref={formRef}
        name="basic"
        labelCol={{
          span: 4,
        }}
        wrapperCol={{
          span: 16,
        }}
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          label="关键字"
          name="str"
          validateTrigger="onBlur"
          rules={[
            {
              required: true,
              message: '请输入关键字',
            },
          ]}
        >
          <Search
            onSearch={onSearch}
            enterButton
          />
        </Form.Item>

      </Form>
      <div>
        {isLoading ? <Spin /> : ''}
        <div dangerouslySetInnerHTML={{ __html: result }}></div>
      </div>
    </>
  )
}
export default App
